/* unplugin-vue-components disabled */import script from "./OrderDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./OrderDrawer.vue?vue&type=style&index=0&id=696d03a6&lang=less"

const __exports__ = script;

export default __exports__